import {ChannelApply} from "../../basic/path"
import RequestModel from "../../basic/requestConfig";

export default {
    getAppList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ChannelApply.getAppList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    getAppIdAndKey(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ChannelApply.getAppIdAndKey,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getApiExample(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ChannelApply.getApiExample,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getApiChannel(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ChannelApply.getApiChannel,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    getAllApiChannel(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ChannelApply.getAllApiChannel,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    createApp(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ChannelApply.createApp,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    updApp(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ChannelApply.updApp,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    updChannel(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ChannelApply.updChannel,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    enableDisableApp(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ChannelApply.enableDisableApp,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    getApiPercent(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ChannelApply.getApiPercent,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
}